  <div class="container-scroller">
    <div class="container-fluid page-body-wrapper full-page-wrapper">
      <div class="content-wrapper d-flex align-items-center auth px-0">
        <div class="row w-100 mx-0">
          <div class="col-lg-4 mx-auto">
            <div class="auth-form-light text-left py-5 px-4 px-sm-5">
              <div class="brand-logo">
                <!-- <img src="../../../assets/icons/logof.svg" alt="logo"> -->
              </div>
              <h4>Sign in to continue.</h4>
              <!-- <h3 class="font-weight-light">Sign in to continue.</h3> -->
              <form #formValues="ngForm" (ngSubmit)="login(formValues)" class="pt-4">

                <div *ngIf="message" class="alert alert-danger" role="alert">
                  Invaild Credentials
                </div>
                <div class="form-group">
                  <input class="form-control form-control-lg" [(ngModel)]="Creds.email" name="email" #email="ngModel"
                    type="text" placeholder="Enter Username" required>
                  <div class="error" *ngIf="email.touched && !email.valid"> Username is
                    required</div>
                </div>
                <div class="form-group">
                  <input class="form-control form-control-lg" [(ngModel)]="Creds.password" name="password"
                    #password="ngModel" type="password" required placeholder="Enter password">
                  <div class="error" *ngIf="password.touched && !password.valid"> Password is
                  </div>
                </div>
                <div class="mt-3">
                  <button class="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn">SIGN IN</button>
                </div>
                <div class="my-2 d-flex justify-content-between align-items-center">
                  <div class="form-check">
                    <label class="form-check-label text-muted">
                      <input type="checkbox" class="form-check-input">
                      Keep me signed in
                    </label>
                  </div>
                  <!-- <a href="#" class="auth-link text-black">Forgot password?</a> -->
                </div>
                <!-- <div class="mb-2">
                  <button type="button" class="btn btn-block btn-facebook auth-form-btn">
                    <i class="ti-facebook mr-2"></i>Connect using facebook
                  </button>
                </div>
                <div class="text-center mt-4 font-weight-light">
                  Don't have an account? <a href="register.html" class="text-primary">Create</a>
                </div> -->
              </form>
            </div>
          </div>
        </div>
      </div>
      <!-- content-wrapper ends -->
    </div>
    <!-- page-body-wrapper ends -->
  </div>



  <div class="container mt-5" id="container">
    <!-- <div class="form-container mt-5 sign-up-container">
    <form action="#">
      <h1>Create Account</h1>
      <div class="social-container">
        <a href="#" class="social"><i class="fab fa-facebook-f"></i></a>
        <a (click)=signInWithGoogle() class="social"><i class="fab fa-google-plus-g"></i></a>
        <a href="#" class="social"><i class="fab fa-linkedin-in"></i></a>
      </div>
      <span>or use your email for registration</span>
      <input type="text" placeholder="Name" />
      <input type="email" placeholder="Email" />
      <input type="password" placeholder="Password" />
      <button>Sign Up</button>
    </form>
  </div> -->
    <div class="form-container sign-in-container">
    </div>
    <!-- <div class="overlay-container">
    <div class="overlay">
      <div class="overlay-panel overlay-left">
        <h1>Welcome Back!</h1>
        <p>To keep connected with us please login with your personal info</p>
        <button class="ghost" id="signIn">Sign In</button>
      </div>
      <div class="overlay-panel overlay-right">
        <h1>Welcome Back!</h1>
        <p>Enter your personal details and start journey with us</p>
        <button class="ghost" id="signUp">Sign Up</button>
      </div>
    </div>
  </div> -->

  </div>
